import { render, staticRenderFns } from "./ViewBookings.vue?vue&type=template&id=376dfed4&scoped=true"
import script from "./ViewBookings.vue?vue&type=script&lang=js"
export * from "./ViewBookings.vue?vue&type=script&lang=js"
import style0 from "./ViewBookings.vue?vue&type=style&index=0&id=376dfed4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376dfed4",
  null
  
)

export default component.exports